// Calcul pour Madelin
// ========================
'use strict';

var Const = require('lib/const');


var calcul = {

  huitPass: 8 * Const.constantes._PASS,
  septPass: 7 * Const.constantes._PASS,

  // Function calculant la cotisation maximale de retraite facultative
  // (10 % * 8 * PASS) + (15 % * 7 * PASS)
  cotisRetFalcMax: function (){
    var ret = 0;

    ret = (0.1 * this.huitPass) + (0.15 * this.septPass);

    return ret;
  },

  // Function calculant la cotisation maximale de prévoyance complémentaire
  // (3 % * 8 * PASS)
  cotisPrevComMax: function() {
    var ret = 0;

    ret = (0.03 * this.huitPass);

    return ret;
  },

  // Function calculant la cotisation maximale de perte d'emploi
  // (1.875 % * 8 * PASS)
  cotisChomMax: function() {
    var ret = 0;

    ret = (0.01875 * this.huitPass);

    return ret;
  },

  // Function calculant la cotisation de retraite facultative
  // La plus élevée des deux limites
  // [(10 % x bénéfice imposable plafonné à 8 fois le PASS)
  // + (15 % x bénéfice imposable plafonné à 7 fois le PASS)]
  // ou (10 % x PASS).

  cotisRetFalc: function(benefice){
    var lim1 = 0,
      lim2 = 0,
      ret = 0;
    var benef = benefice || 1;

    lim1 = (0.1 * Math.min(benef, this.huitPass)) + (0.15 * Math.min((benef-Const.constantes._PASS), this.septPass));
    lim2 = 0.1 * Const.constantes._PASS;

    ret = Math.max(lim1, lim2);

    return ret;
  },

  // Function calculant la cotisation de prévoyance facultative
  // double limite :
  // [(7 % x PASS) + (3,75 % x bénéfice imposable)],
  // et (3 % x 8 fois le PASS)
  cotisPrevFalc: function(benefice){
    var lim1 = 0,
      lim2 = 0,
      ret = 0;
    var benef = benefice || 1;

    lim1 = 0.07 * Const.constantes._PASS + (0.0375 * benef);
    lim2 = 0.03 * this.huitPass;

    ret = Math.min(lim1, lim2);

    return ret;
  },

  // Function calculant la cotisation de prévoyance facultative
  // La plus élevée des deux limites :
  // (2,5 % x PASS),
  // ou (1,875 % x bénéfice imposable plafonné à 8 fois le PASS)
  cotisChomFalc: function(benefice){
    var lim1 = 0,
      lim2 = 0,
      ret = 0;
    var benef = benefice || 1;

    lim1 = 0.025 * Const.constantes._PASS;
    lim2 = 0.01875 * Math.min(benef, this.huitPass);

    ret = Math.max(lim1, lim2);

    return ret;
  },

  onChangeTmi: function(data){
    var ret = 0;

    ret = data.get('cotisAn') * data.get('tmi');
    data.set('ecoImpEstime', ret);

    return data;
}
};

module.exports = calcul;